/**
 * Game SFX: play helpers + mute toggle (persisted via soundStore).
 */

import { useSoundStore } from '../stores/soundStore';
import type { SoundId, SnackbarSoundVariant } from '../constants/sounds.constants';

interface UseSoundReturn {
  playSound: (id: SoundId) => void;
  playUiSuccessBrief: () => void;
  playForSnackbarVariant: (variant: SnackbarSoundVariant) => void;
  playUiTapBrief: (soundId?: SoundId) => void;
  isMuted: boolean;
  toggleMute: () => void;
  setMuted: (muted: boolean) => void;
}

export const useSound = (): UseSoundReturn => {
  const playSound = useSoundStore((s) => s.playSound);
  const playUiSuccessBrief = useSoundStore((s) => s.playUiSuccessBrief);
  const playForSnackbarVariant = useSoundStore((s) => s.playForSnackbarVariant);
  const playUiTapBrief = useSoundStore((s) => s.playUiTapBrief);
  const isMuted = useSoundStore((s) => s.isMuted);
  const toggleMute = useSoundStore((s) => s.toggleMute);
  const setMuted = useSoundStore((s) => s.setMuted);
  return { playSound, playUiSuccessBrief, playForSnackbarVariant, playUiTapBrief, isMuted, toggleMute, setMuted };
};
